/*
===============================================================================================================
                                 Copyright 2022-2022, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

const statuses = {
  NONE: Symbol('none'),
  SENDING: Symbol('sending'),
  SENT: Symbol('sent'),
  FAILED: Symbol('failed'),
};

export default statuses;
